import type { Moment } from 'moment';

import { Default, Mapper, View } from './decorators';
import { EntityBase } from './entity-base';
import { FieldViewType } from './enums';
import { momentMapper } from './mappers';

export abstract class Entity extends EntityBase {

	@Mapper(momentMapper)
	@View(FieldViewType.moment, () => 'LLL')
	@Default(null)
	created!: Moment | null;

	@Mapper(momentMapper)
	@View(FieldViewType.moment, () => 'LLL')
	@Default(null)
	modified!: Moment | null;

}
